module.exports = __webpack_public_path__ + "static/customize-7a4ee52c83d56106e447a325f3803647.svg";